import { z } from "zod"

// Re-export all schemas and types from individual modules
export {
  DurationSchema, TimelineSchema, PositionSchema,
  type Duration, type Timeline, type Position,
} from "./timing"

export {
  CaptionTextElementSchema, CaptionContentSchema, CaptionSegmentSchema,
  FontConfigSchema, ColorConfigSchema, StrokeConfigSchema, ShadowConfigSchema,
  CaptionStyleConfigSchema, CaptionKeywordSchema, CaptionEmojiMarkSchema, AICaptionsSchema,
  type CaptionTextElement, type CaptionContent, type CaptionSegment,
  type FontConfig, type ColorConfig, type StrokeConfig, type ShadowConfig,
  type CaptionStyleConfig, type CaptionKeyword, type CaptionEmojiMark, type AICaptions,
} from "./caption"

export {
  TextStyleSchema, HookTextElementSchema, HookContentSchema, HookSegmentSchema,
  type TextStyle, type HookTextElement, type TextElement, type HookContent, type HookSegment,
} from "./hook"

export {
  BRollMediaInfoSchema, BRollContentSchema, BRollSegmentSchema,
  type BRollMediaInfo, type BRollContent, type BRollSegment,
  type BRollSegmentType, type BRollMotion, type BRollStyle,
} from "./broll"

export {
  MusicAudioSettingsSchema, MusicMediaInfoSchema, MusicContentSchema, MusicSegmentSchema,
  type MusicAudioSettings, type MusicMediaInfo, type MusicContent, type MusicSegment,
} from "./music"

export {
  VoiceoverAudioSettingsSchema, VoiceoverMediaInfoSchema, VoiceoverContentSchema, VoiceoverSegmentSchema,
  type VoiceoverAudioSettings, type VoiceoverMediaInfo, type VoiceoverContent, type VoiceoverSegment,
} from "./voiceover"

export {
  GifMediaInfoSchema, GifAudioSettingsSchema, GifContentSchema, GifSegmentSchema,
  DEFAULT_GIF_POSITION,
  type GifMediaInfo, type GifAudioSettings, type GifContent, type GifSegment, type GifSegmentType,
} from "./gif"

export {
  EmojiContentSchema, EmojiSegmentSchema,
  type EmojiContent, type EmojiSegment,
} from "./emoji"

export {
  EffectTypeSchema, ZoomParamsSchema, CameraShakeParamsSchema,
  ColorGradeParamsSchema, OverlayShapeParamsSchema,
  FlashParamsSchema, VignetteParamsSchema, EffectSegmentSchema,
  type EffectType, type ZoomParams, type CameraShakeParams,
  type ColorGradeParams, type OverlayShapeParams,
  type FlashParams, type VignetteParams, type EffectSegment,
} from "./effects"

export {
  ReframeKeyframeSchema, ReframeConfigSchema, FaceTrackSchema, SceneSchema,
  ReframeContentSchema, ReframeSegmentSchema,
  DEFAULT_REFRAME_CONFIG,
  type ReframeKeyframe, type ReframeConfig, type FaceTrack, type Scene,
  type ReframeContent, type ReframeSegment, type ReframeFaceTrack, type ReframeScene,
} from "./reframe"

export {
  TrackTypeSchema, SectionSchema, TrackSchema,
  RenderPreferencesSchema, ReframeBoundsSchema,
  AutoHookTextOverlaySchema, AutoHookSchema,
  SceneFaceSchema, FaceKeyframeSchema, LayoutCheckSchema, SceneChunkSchema, SceneTransitionSchema, SceneMetadataSchema,
  CutRangeSchema,
  EditingScriptSchema,
  DEFAULT_TEXT_STYLE, DEFAULT_POSITION, DEFAULT_CAPTION_STYLE_CONFIG, DEFAULT_RENDER_PREFERENCES,
  type Segment,
  type TrackType, type Section, type Track,
  type RenderPreferences, type ReframeBounds,
  type AutoHookTextOverlay, type AutoHook,
  type SceneFace, type FaceKeyframe, type SceneChunk, type SceneTransition, type SceneMetadata,
  type EditingScript,
  type CaptionTrack, type HookTrackType, type EmojiTrackType,
  type BRollTrackType, type MusicTrackType, type VoiceoverTrackType,
  type GifTrackType, type ReframeTrackType,
} from "./editing-script"

// CompositionProps is the same as EditingScript — used by both <Player> and renderMediaOnLambda
import { EditingScriptSchema } from "./editing-script"
export const CompositionPropsSchema = EditingScriptSchema
export type CompositionProps = z.infer<typeof CompositionPropsSchema>
